var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shake"}},[_c('div',{staticClass:"bacViews"},[_c('div',{staticClass:"shakeview"},[_c('shakeView',{staticStyle:{"margin":"0 auto"},attrs:{"openid":_vm.openid},on:{"data-info":_vm.getResultCode}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }